import { Pipe, PipeTransform } from '@angular/core';
import { Product } from '../Interfaces/product';

const defaultSingle = 'יחידות';
const alternateSingle = 'משקל';
const defaultPack = 'אריזות';
const alternatePack = 'קופסאות';

@Pipe({
	name: 'weightTypeText',
})
export class WeightTypeTextPipe implements PipeTransform {
	transform(product: Product, quantity: 'single' | 'pack'): string {
		if (!product) return '';
		if (quantity === 'single') {
			if (!('Type' in product)) return defaultSingle;
			if ('weightMode' in product) {
				if (product.weightMode === 'singles') return defaultSingle;
				if (product.weightMode === 'weight') return alternateSingle;
			}
			const type = product.Type;
			const typeAsString = type.toString();
			if (typeAsString.includes('2')) {
				return defaultSingle;
			}

			// if type is 0
			if (!type) {
				return alternateSingle;
			}

			//fallback
			return defaultSingle;
		}

		if (quantity === 'pack') {
			if (!('Type' in product)) return defaultPack;

			const type = product.Type;
			const typeAsString = type.toString();

			if (typeAsString.includes('3')) {
				return alternatePack;
			}

			if (!product.Type || type === 4) {
				return defaultPack;
			}

			//fallback
			return defaultPack;
		}

		return '';
	}
}
